import Bubble from '../bubble'
// import { Spin } from 'antd'

interface LoadingProps {
  loading?: boolean
  loadingText?: string
}

const Loading = (props: LoadingProps) => {
  const {
    // loadingText = '资料库检索中..',
    loading = true
  } = props

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '34px',
        padding: '12px 0'
      }}
    >
      <Bubble
        content={'node.value.text'}
        // loadingRender={() => (
        //   <>
        //     <Spin size="small" />
        //     <span className='y-ml-10 y-text-gray-700' style={{
        //       color: 'rgba(0, 0, 0, 0.88)'
        //     }}>
        //       {loadingText}
        //     </span>
        //   </>
        // )}
        loading={loading}
      ></Bubble>
    </div>
  )
}

export default Loading
